import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://rchyocvcskswoudqrjrf.supabase.co';
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJjaHlvY3Zjc2tzd291ZHFyanJmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ4MzI5MTgsImV4cCI6MjA5MDQwODkxOH0.m07ATJVXQSfBzVJXu2PN_WRL6wwk9GsE3wb1mZKDWJc';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON);
